import { render, staticRenderFns } from "./ReChannelBig.vue?vue&type=template&id=d7973402&scoped=true"
import script from "./ReChannelBig.vue?vue&type=script&lang=js"
export * from "./ReChannelBig.vue?vue&type=script&lang=js"
import style0 from "./ReChannelBig.vue?vue&type=style&index=0&id=d7973402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7973402",
  null
  
)

export default component.exports